import { render } from "./TicketStatusView.vue?vue&type=template&id=b813d51a"
import script from "./TicketStatusView.vue?vue&type=script&lang=js"
export * from "./TicketStatusView.vue?vue&type=script&lang=js"

import "./TicketStatusView.vue?vue&type=style&index=0&id=b813d51a&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__